import React, { FC, useCallback, useContext, useEffect, useState } from 'react';

import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../store';
import { IAward } from '../../../../store/admin/eventAwards/store';

import AssignAwardsTable from '../Common/AssignAwardsTable/AssignAwardsTable';
import { useFormattedAwards } from '../Common/AssignAwardsTable/Hooks/useFormattedAwards.hook';
import AssignResults from '../Common/AssignResults/AssignResults';
import { AssignResultsSectionSelector } from '../Common/AssignResultsSectionSelector/AssignResultsSectionSelector';
import { blankAward } from '../Common/Utils/blankAward';
import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';
import { useResultsSectionSelector } from './useResultsSectionSelector';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';

const AssignRoundAwards: FC = () => {
  const { clubId, eventId, roundId } = useRouteInfoState();

  const {
    actions: {
      adminRoundAwards: {
        create: createRoundAward,
        delete: deleteRoundAward,
        get: getRoundAward,
        update: updateRoundAward
      }
    },
    adminRoundAwards
  } = useContext(GlobalContext);

  useEffect(() => {
    getRoundAward(clubId, eventId, roundId);
  }, [clubId, eventId, roundId]);

  const onContinue = () =>
    navigate(`/staff/club/${clubId}/event/${eventId}/round/${roundId}/complete`);

  const [awards] = useFormattedAwards(Number(roundId), adminRoundAwards);

  const deleteAwards = useCallback((awardId: number) => {
    deleteRoundAward(clubId, eventId, roundId, awardId);
  }, []);

  const createAwards = useCallback(
    (award: IAward) => createRoundAward(clubId, eventId, roundId, award),
    [clubId, eventId, roundId]
  );

  const updateAwards = useCallback(
    (awardId: number, award: IAward) => updateRoundAward(clubId, eventId, roundId, awardId, award),
    [clubId, eventId, roundId]
  );

  const [newAward, setNewAward] = useState(blankAward);

  const [sectionSelected, onSectionOnClick] = useResultsSectionSelector();

  return (
    <div className="event-wizard-page round-setup">
      <div className="event-wizard-round-awards">
        <EventWizardStepTitle buttonText="CONTINUE" buttonOnClick={onContinue} title="" />

        <AssignResultsSectionSelector
          // Disabled due to https://code.talpor.com/club15/frontend/-/issues/888
          // otherAwardsOnClick={onSectionOnClick('OtherAwards')}
          leaderboardsOnClick={onSectionOnClick('Leaderboards')}
          sectionSelected={sectionSelected}
        />

        {sectionSelected === 'Leaderboards' ? (
          <AssignResults />
        ) : (
          <AssignAwardsTable
            awards={awards}
            createAwards={createAwards}
            deleteAwards={deleteAwards}
            eventId={Number(eventId)}
            forceShowNewAwardRow={true}
            newAward={newAward}
            setNewAward={setNewAward}
            updateAwards={updateAwards}
          />
        )}
      </div>
    </div>
  );
};

export default AssignRoundAwards;
